import { Link, useLocation } from "react-router-dom";
import Icon from "./ui/Image";
import { useSelector } from "react-redux";
import { settingSelector } from "../store/features/settingSlice";
import { AnimatePresence, motion } from "framer-motion";
import CustomLink from "./ui/CustomLink";
import { loginSelector } from "@/store/features/loginSlice";

interface HeaderProps {
  hideLink?: boolean;
}

const Header: React.FC<HeaderProps> = ({ hideLink = false }) => {
  const { isOnline } = useSelector(settingSelector);
  const { currentUser } = useSelector(loginSelector);
  const location = useLocation();
  const isLoginPage = location.pathname?.includes("/login");
  const btnText = isLoginPage ? "Sign up" : "Login";
  const btnLink = isLoginPage ? "/" : "/login";

  return (
    <header className="h-12 shadow-header fixed md:sticky top-0 z-10 bg-white w-full">
      {currentUser !== undefined && (
        <div className="flex px-5 xl:px-0 items-center justify-between max-w-mainContainer mx-auto h-full">
          <div className="flex items-start">
            <Link to="/">
              <Icon src="/icons/logo.svg" alt="logo" />
            </Link>
            <AnimatePresence>
              {!isOnline && (
                <motion.div
                  initial={{ opacity: 0, y: -50 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -50 }}
                  transition={{ duration: 0.3 }}
                  className={` text-gray-500 rounded-full flex items-center gap-0.5`}
                >
                  <span className=" text-xs leading-normal -translate-x-2.5">{"offline"}</span>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          {!hideLink && (
            <div className="flex justify-end items-center gap-4">
              <div className=" text-text-label text-13 !leading-normal hidden md:block">{isLoginPage ? "New to Lystproof?" : "Already have an account?"}</div>
              <CustomLink link={{ value: btnLink, text: btnText }} variant="header" className="!text-10 md:!text-13 md:min-w-72" />
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export default Header;
